import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "../../lib/data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-nav" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center gap-3 group"
          >
            <img
              src={BRAND.logoUrl}
              alt="Zénith Plage"
              className="h-12 w-12 md:h-14 md:w-14 rounded-full object-cover"
            />
            <div className="hidden sm:block leading-tight">
              <div
                className={`font-serif text-xl md:text-2xl font-medium tracking-tight transition-colors duration-500 ${
                  scrolled ? "text-zp-navy" : "text-white"
                }`}
              >
                Zénith Plage
              </div>
              <div
                className={`text-[10px] uppercase tracking-[0.28em] mt-0.5 transition-colors duration-500 ${
                  scrolled ? "text-zp-muted" : "text-white/80"
                }`}
              >
                Palavas-les-Flots
              </div>
            </div>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-10">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.href.replace("#", "")}`}
                className={`link-underline text-sm font-medium tracking-wide transition-colors duration-500 ${
                  scrolled ? "text-zp-navy hover:text-zp-navyHover" : "text-white hover:text-zp-lemon"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA + phone */}
          <div className="hidden lg:flex items-center gap-5">
            <a
              href={BRAND.phoneHref}
              data-testid="header-phone"
              className={`text-sm font-medium tracking-wide transition-colors duration-500 ${
                scrolled ? "text-zp-navy" : "text-white"
              }`}
            >
              {BRAND.phone}
            </a>
            <a
              href={BRAND.phoneHref}
              data-testid="header-cta-reserve"
              className="btn-accent"
            >
              Appelez-nous
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            className={`lg:hidden p-2 transition-colors ${
              scrolled ? "text-zp-navy" : "text-white"
            }`}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-zp-cream border-t border-zp-line"
        >
          <nav className="px-6 py-8 flex flex-col gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${link.href.replace("#", "")}`}
                className="font-serif text-3xl text-zp-navy"
              >
                {link.label}
              </a>
            ))}
            <a
              href={BRAND.phoneHref}
              className="text-sm tracking-widest text-zp-muted mt-2"
            >
              {BRAND.phone}
            </a>
            <a
              href={BRAND.phoneHref}
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-reserve"
              className="btn-accent self-start mt-2"
            >
              Appelez-nous
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
